import { SimpleGrid, Box, VStack, Text } from "@chakra-ui/react";
import ChakraUIRenderer from "chakra-ui-markdown-renderer";
import ReactMarkdown from "react-markdown";
import { useNavigate } from "react-router-dom";
import remarkGfm from "remark-gfm";
import NavMenu from "../../components/Menu";
import { useEffect, useState } from "react";

const ROUTING_API_LIST = [
  // {
  //   label: "Routing",
  //   path: "routing-api",
  // },
  // {
  //   label: "Route Planner",
  //   path: "route-planner-api",
  // },
  // {
  //   label: "Route Matrix",
  //   path: "route-matrix-api",
  // },
  {
    label: "Route Planner V4",
    path: "route-planner-api-v4",
  },
  {
    label: "Route Planner V3",
    path: "route-planner-api-v3",
  },
  {
    label: "Routing V3",
    path: "routing-api-v3",
  },
  {
    label: "Routing V4",
    path: "routing-api-v4",
  },
  {
    label: "Routing-2 V4",
    path: "routing-2-api-v4",
  },
  {
    label: "Route Matrix V3",
    path: "route-matrix-api-v3",
  },
  {
    label: "Route Matrix V4",
    path: "route-matrix-2-api-v4",
  },
  {
    label: "Route Matrix-2 V4",
    path: "route-matrix-2-api-v4",
  },
  {
    label: "Map Matching",
    path: "map-matching-api",
  },
  // {
  //   label: "Route Matrix V4",
  //   path: "route-matrix-api-v4",
  // },
];

const GEOCODING_API_LIST = [
  {
    label: "Search (Geocoding)",
    path: "search-api",
  },
  {
    label: "Reverse Geocoding",
    path: "reverse-api",
  },
  {
    label: "Autocomplete",
    path: "autocomplete-api",
  },
  {
    label: "Place",
    path: "place-api",
  },
];

const ADDRESS_API_LIST = [
  {
    label: "Address Parsing",
    path: "address-parsing-api",
  },
  {
    label: "Address Validation",
    path: "address-validation-api",
  },
];

const OTHER_API_LIST = [
  {
    label: "Buildings",
    path: "buildings-api",
  },
  {
    label: "Location Image",
    path: "location-image-api",
  },
];

export default function HomePage() {
  const [postContent, setPostContent] = useState("");

  const navigate = useNavigate();

  // Getting the md document
  useEffect(() => {
    import("../home/home.md").then((res) => {
      fetch(res.default)
        .then((response) => response.text())
        .then((response) => setPostContent(response))
        .catch((err) => console.log(err));
    });
  }, []);

  return (
    <VStack backgroundColor={"#e0e0e0"} h="100vh" overflow="auto">
      <NavMenu />
      <article className="article">
        <div className="container">
          <div className="post-wrapper">
            <ReactMarkdown
              components={ChakraUIRenderer()}
              children={postContent}
              remarkPlugins={[remarkGfm]}
              skipHtml
            />
            <br />

            <Text fontWeight={"bold"} fontSize={"lg"}>
              Routing APIs:
            </Text>

            <SimpleGrid columns={[1, 2, 3]} spacingX="30px" spacingY="10px">
              {ROUTING_API_LIST.map((api) => (
                <Box
                  display="flex"
                  bg="#e7e7e7"
                  p={3}
                  _hover={{
                    textDecoration: "underline",
                  }}
                  cursor="pointer"
                  justifyContent="center"
                  alignItems="center"
                  boxShadow={
                    "inset -2px -2px 3px #c9c9c9, inset 2px 2px 3px #ffffff"
                  }
                  borderRadius={"50px"}
                  onClick={() => navigate(api.path)}
                >
                  <Text fontSize="xl" fontWeight={"semibold"} color="#212121">
                    {api.label}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
            <br />
            <br />

            <Text fontWeight={"bold"} fontSize={"lg"}>
              Geocoding APIs:
            </Text>

            <SimpleGrid columns={[1, 2, 3]} spacingX="30px" spacingY="10px">
              {GEOCODING_API_LIST.map((api) => (
                <Box
                  display="flex"
                  bg="#e7e7e7"
                  p={3}
                  _hover={{
                    textDecoration: "underline",
                  }}
                  cursor="pointer"
                  justifyContent="center"
                  alignItems="center"
                  boxShadow={
                    "inset -2px -2px 3px #c9c9c9, inset 2px 2px 3px #ffffff"
                  }
                  borderRadius={"50px"}
                  onClick={() => navigate(api.path)}
                >
                  <Text fontSize="xl" fontWeight={"semibold"} color="#212121">
                    {api.label}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
            <br />
            <br />

            <Text fontWeight={"bold"} fontSize={"lg"}>
              Address APIs:
            </Text>

            <SimpleGrid columns={[1, 2, 3]} spacingX="30px" spacingY="10px">
              {ADDRESS_API_LIST.map((api) => (
                <Box
                  display="flex"
                  bg="#e7e7e7"
                  p={3}
                  _hover={{
                    textDecoration: "underline",
                  }}
                  cursor="pointer"
                  justifyContent="center"
                  alignItems="center"
                  boxShadow={
                    "inset -2px -2px 3px #c9c9c9, inset 2px 2px 3px #ffffff"
                  }
                  borderRadius={"50px"}
                  onClick={() => navigate(api.path)}
                >
                  <Text fontSize="xl" fontWeight={"semibold"} color="#212121">
                    {api.label}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
            <br />
            <br />

            <Text fontWeight={"bold"} fontSize={"lg"}>
              Other APIs:
            </Text>

            <SimpleGrid columns={[1, 2, 3]} spacingX="30px" spacingY="10px">
              {OTHER_API_LIST.map((api) => (
                <Box
                  display="flex"
                  bg="#e7e7e7"
                  p={3}
                  _hover={{
                    textDecoration: "underline",
                  }}
                  cursor="pointer"
                  justifyContent="center"
                  alignItems="center"
                  boxShadow={
                    "inset -2px -2px 3px #c9c9c9, inset 2px 2px 3px #ffffff"
                  }
                  borderRadius={"50px"}
                  onClick={() => navigate(api.path)}
                >
                  <Text fontSize="xl" fontWeight={"semibold"} color="#212121">
                    {api.label}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
          </div>
        </div>
      </article>
    </VStack>
  );
}
